<template>
	<div class="rankings" ref="rankingsPage">
		<el-table :data="rankingsList" border class="subject-table" height="100%">
			<el-table-column :resizable="false" label="名次" align="center" min-width="70">
				<template slot-scope="scope">
					<div v-if="parseInt(scope.$index+1) <= 3">
						<img class="ranking-num" :src="require('@/assets/img/simulationGame/ranking' + (scope.$index+1) + '.png')"
							alt="">
					</div>
					<div v-else>{{ (scope.$index+1).toString().padStart(2, "0") }}</div>
				</template>
			</el-table-column>
			<el-table-column :resizable="false" prop="nickname" label="参赛者" align="center" min-width="100"></el-table-column>
			<el-table-column :resizable="false" prop="department_name" label="中心" align="center" min-width="180">
				<template slot-scope="scope">
					<template v-if="scope.row.department_name.indexOf('（') != -1">
						{{scope.row.department_name.substring(scope.row.department_name.indexOf("（") + 1, scope.row.department_name.indexOf("）"))}}
					</template>
					<template v-else-if="scope.row.department_name.indexOf('(') != -1">
						{{scope.row.department_name.substring(scope.row.department_name.indexOf("(") + 1, scope.row.department_name.indexOf(")"))}}
					</template>
					<template v-else>
						{{scope.row.department_name}}
					</template>
				</template>
			</el-table-column>
			<el-table-column :resizable="false" prop="score" label="总分" align="center" min-width="65"></el-table-column>
			<template v-for="(item, index) in subjectNum">
				<el-table-column :resizable="false" :key="index" :label="(index+1).toString()" align="center" min-width="60">
					<template slot-scope="scope">
						{{scope.row['score'+index]}}
					</template>
				</el-table-column>
			</template>
		</el-table>
	</div>
</template>

<script>
	import {
		getRankList
	} from '@/api/simulationGame'
	export default {
		name: "rankings",
		components: {},
		props: {
			examGroundId: String
		},
		data() {
			return {
				tableHeight: 400,
				rankingsList: [],
				page: {
					currentPage: 1,
					pageSize: 10,
					total: 35,
				},
				subjectNum: 0, // 题目数量
			}
		},
		created() {
			this.getRankList();
		},
		mounted() {
			this.setTableHeight();
		},
		watch: {},
		methods: {
			changeCurrentPage(val) { // 切换分页
				this.page.currentPage = val
				this.getRankList();
			},
			setTableHeight() { // 设置表格高度
				this.$nextTick(() => {
					const divHeight = this.$refs.rankingsPage.offsetHeight;
					this.tableHeight = divHeight - 20 - 25 - 60;
				});
			},
			async getRankList() {
				let res = await getRankList({
					examGroundId: this.examGroundId,
					pageSize: this.page.pageSize,
					page: this.page.currentPage
				});
				if (res.status) {
					// console.log("排行榜",JSON.parse(JSON.stringify(res.data)));
					this.page.total = res.data.rankList.total;
					this.page.pageSize = res.data.rankList.per_page;
					this.page.currentPage = res.data.rankList.current_page;
					this.rankingsList = res.data.rankList.data;
					this.rankingsList.map((a, i) => {
						let problemScore = a.problem_score;
						if(problemScore){
							this.subjectNum = problemScore.length;
							problemScore.map((item, index) => {
								a["sort" + index] = item.sort;
								a["score" + index] = item.score;
							})
						}
					})
				}
			},
		}
	}
</script>

<style lang="scss" scoped>
	.rankings {
		height: calc(100% - 1.6rem);
		padding: 0.8rem 2.12rem;

		.ranking-num {
			width: 2.72rem;
			height: 2.64rem;
			display: block;
			margin: 0 auto;
		}

		.el-pagination {
			text-align: right;
			padding-bottom: 1rem;
		}


		::v-deep.el-table.subject-table {
			display: flex;
			flex-direction: column;
			margin-bottom: 1rem;
			background: none;

			.hideColumn {
				display: none;
			}

			.el-table__header-wrapper .el-table__header {

				tr,
				.el-table__cell {
					background-color: #184155;
				}

				tr th {
					font-family: Source Han Sans SC;
					font-weight: 500;
					font-size: 1.28rem;
					color: #81FEFF;

					.cell {
						line-height: initial;
					}
				}
			}

			.el-table__body-wrapper {
				position: relative;
				flex: 1;

				tr td {
					font-family: Source Han Sans SC;
					font-weight: 500;
					font-size: 1.2rem;
					padding: 0;
					height: 2.8rem;

					.cell {
						line-height: initial;
						padding: 0;
					}
				}

				th.el-table__cell,
				tr,
				.el-table__empty-block {
					background-color: rgba(28, 53, 70, 1);
				}
			}
		}

		// 分页样式
		::v-deep .el-pagination {

			.el-pagination__jump,
			.el-pagination__total {
				color: #FFF;
				font-size: 0.72rem;
			}

			.btn-next,
			.btn-prev,
			.el-pager li {
				background-color: #748C9A;
				color: #C2E9FF;
			}

			.el-pager li:not(.disabled).active {
				background-color: #41A2E2;
				color: #FFF;
			}

			.el-input.is-in-pagination {
				top: -0.08rem;
			}

			.el-input__inner {
				background-color: #748C9A;
				border-color: #1FB1C3;
				color: #FFF;
			}
		}
	}
</style>
